import { render, staticRenderFns } from "./UnassignedLearnerActionButton.vue?vue&type=template&id=3eb5e124&"
import script from "./UnassignedLearnerActionButton.vue?vue&type=script&lang=js&"
export * from "./UnassignedLearnerActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports